import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { IconPlusCircleFilled } from "@hubble/icons";
import { Card, mediaQuery } from "@hubble/web";

export const Wrapper = styled.div<{ flipped: boolean }>`
  @media ${mediaQuery.mobileXsDown} {
    ${({ flipped }) =>
      flipped &&
      `
      top: 0px;
      height: 100%;
      width:100%;
      z-index: 10;
      position: fixed;
      left: 0px;
  `};
  }

  border: none;
  border-radius: 16px;
  perspective: 1500px;
  position: relative;
  min-height: 74px;
  height: 100%;
`;

export const CardInner = styled.div<{ flip: boolean; time: number }>`
  width: 100%;
  height: 100%;
  position: relative;
  transition: transform 1s;
  transform-style: preserve-3d;
  @media ${mediaQuery.tabletSmUp} {
    ${({ flip }) => flip && `transform: rotateY(180deg);`}
    ${({ time }) => `transition: transform ${time}s;`}
  }
`;

export const CardBase = styled(Card)<{
  background?: string;
  backgroundImage?: string;
}>`
  box-sizing: border-box;
  border: none;
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 16px;
  backface-visibility: hidden;
  ${({ background }) => background && `background: ${background};`}
`;

export const CardFront = styled(CardBase)<{ cursor?: string }>`
  ${({ cursor }) => cursor && `cursor: ${cursor};`}
  transform: rotateY(0deg);
`;

export const CardBack = styled(CardBase)<{ flipped: boolean }>`
  transform: rotateY(180deg);
  @media ${mediaQuery.mobileXsDown} {
    ${({ flipped }) =>
      flipped &&
      `
      border-radius: unset;
      transform: rotateY(0deg);
      top: 60px; // nav bar height
      height: 100%;
      position: fixed;
      left: 0px;
      min-height: 100vh;
      padding: 120px 41px 0px 41px;
    `};
  }
`;

const baseFlipButtonStyles = css`
  height: 32px;
  width: 32px;
  position: absolute;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
`;
export const FlipButton = styled(IconPlusCircleFilled)`
  ${baseFlipButtonStyles}
  ${({ theme: { colorScheme, isDark } }) => `
  opacity: ${isDark ? 0.5 : 0.25};
  color: ${colorScheme.content.primary};
  `};
`;

export const CloseButton = styled(IconPlusCircleFilled)`
  // flip position of button to upper left
  @media ${mediaQuery.mobileXsDown} {
    left: 20px;
    top: 20px;
  }
  ${baseFlipButtonStyles}
  transform: rotate(45deg);
  ${({ theme: { colorScheme } }) => `
  color: ${colorScheme.content.primary};
  `};
`;
